//@*/*
//    *RPD  Appv0.91
//    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
//    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
//    */
//

/* eslint-disable */

const home = () => import("../components/home.vue");
const pagenoutfound = () => import("../components/pagenoutfound.vue");
const rec_workcards = () => import("../components/wcrd_workcards.vue");
const doc_one_rec_guide = () => import("../components/doc_one_rec_guide.vue");
const doc_ret_guide = () => import("../components/doc_ret_guide.vue");

export const routes = [
  { name: "home", path: "/", component: home, display: "Home", icon: "Home" },
  {
    name: "rec_workcards",
    path: "/workcards",
    component: rec_workcards,
    display: "Work Cards",
  },
  {
    name: "guide",
    path: "/guide",
    component: doc_one_rec_guide,
    display: "Guide",
  },
  {
    name: "retrieve",
    path: "/retrieve",
    component: doc_ret_guide,
    display: "Retrieve",
  },
  { name: "not-found", path: "/:pathMatch(.*)*", component: pagenoutfound },
];
